<template>
  <div>
    <div class="grid grid-cols-2 col-gap-1 row-gap-4">
      <div class="col-span-2">
        <h1>Slideshows</h1>
      </div>

      <div class="col-span-2">
        <div class="w-full">
          <vue-good-table :columns="columns" :rows="slideshowOptions">
            <template slot="table-row" slot-scope="props">
              <span v-if="props.column.field == 'id'">
                <base-button-white-extra-small
                  @click="handleDelete(props.row)"
                  class="ml-3"
                >
                  Delete
                </base-button-white-extra-small>
              </span>
              <span
                v-else-if="props.column.field == 'link'"
                v-html="makeLink(props.row)"
              >
              </span>
              <span v-else>
                {{ props.formattedRow[props.column.field] }}
              </span>
            </template>
          </vue-good-table>
        </div>
      </div>

      <div class="col-span-2">
        <base-label>Date</base-label>
        <el-date-picker
          @change="handleDateChange"
          v-model="date"
          type="date"
          placeholder="Pick a day"
          class="w-full"
        >
        </el-date-picker>
      </div>
      <div v-if="date">
        <base-label>Display Groups</base-label>
        <el-select
          v-model="displayGroupSelected"
          @change="handleDisplayGroupSelect"
          placeholder="Select"
          class="w-full"
        >
          <el-option
            v-for="displayGroup in displayGroupOptions"
            :key="displayGroup.id"
            :label="displayGroup.name"
            :value="displayGroup.id"
          >
          </el-option>
        </el-select>
      </div>
      <div v-if="date">
        <base-label>Slideshows</base-label>
        <el-select
          v-model="slideshowSelected"
          @change="handleSlideshowChange"
          placeholder="Select"
          class="w-full"
        >
          <el-option
            v-for="slideshow in slideshowOptions"
            :key="slideshow.id"
            :label="slideshow.name"
            :value="slideshow.id"
          >
          </el-option>
          <el-option label="Create New" value="new"></el-option>
        </el-select>
      </div>
      <div v-if="slideshowSelected">
        <base-button-primary @click="addAll"
          >Add all images</base-button-primary
        >
      </div>
      <div v-if="slideshowSelected">
        <base-button-primary class="float-right" @click="handleEditSlideshow"
          >Edit Slideshow</base-button-primary
        >
      </div>
      <div class="grid grid-cols-2 gap-2 drop-zone">
        <div
          v-for="photo in displayGroup.photos"
          :key="photo.id"
          @click="handleClick(photo.id, 'slideshow')"
          class="text-center mt-3 drag-el"
        >
          <img
            ref="displayGroupImage"
            style="max-height: 125px; margin-left: auto; margin-right: auto"
          />
        </div>
      </div>
      <div class="grid grid-cols-2 gap-2 drop-zone">
        <div
          v-for="photo in slideshow.photos"
          :key="photo.id"
          @click="handleClick(photo.id, 'displayGroup')"
          class="text-center mt-3 drag-el"
        >
          <img
            ref="slideshowImage"
            style="max-height: 125px; margin-left: auto; margin-right: auto"
          />
        </div>
      </div>
    </div>

    <base-modal
      :show="showModal"
      @close="showModal = false"
      @save="saveSlideshow"
    >
      <template v-slot:header> Slideshow </template>
      <template v-slot:main>
        <div class="grid grid-cols-1 gap-4">
          <div class="col">
            <base-label>Name</base-label>
            <base-input v-model="modalSlideshow.name" />
          </div>
          <div class="col">
            <base-label>Interval</base-label>
            <base-input v-model="modalSlideshow.interval" />
          </div>
        </div>
      </template>
    </base-modal>
  </div>
</template>

<script>
import photo from "../../mixins/photo";
import BaseButtonPrimary from "@/components/ui/buttons/BaseButtonPrimary";
import "vue-good-table/dist/vue-good-table.css";
import { VueGoodTable } from "vue-good-table";

export default {
  name: "Slideshows",
  components: { BaseButtonPrimary, VueGoodTable },
  mixins: [photo],
  data() {
    return {
      showModal: false,
      date: null,
      displayGroupSelected: null,
      displayGroupOptions: [],
      slideshowSelected: null,
      slideshowOptions: [],
      modalSlideshow: {
        id: null,
        name: null,
        interval: 5,
      },
      slideshow: {
        photos: [],
      },
      displayGroup: {
        photos: [],
      },
      columns: [
        {
          label: "Name",
          field: "name",
        },
        {
          label: "Interval",
          field: "interval",
        },
        {
          label: "Link",
          field: "link",
          sortable: false,
        },
        {
          label: "",
          field: "id",
          sortable: false,
        },
      ],
    };
  },
  methods: {
    addAll() {
      this.displayGroup.photos.forEach((photo) => {
        this.$store.dispatch("slideshows/add_photo", {
          photoId: photo.id,
          slideshowId: this.slideshow.id,
        });
        this.slideshow.photos.push(photo);
      });
      this.displayGroup.photos = [];
      this.populateSlideshow();
    },
    makeLink(row) {
      const link =
        window.location.protocol +
        "//" +
        window.location.host +
        "/slideshow/" +
        row.id;
      return (
        "<a class = 'link' target = '_blank' href = '" +
        link +
        "'>" +
        link +
        "</a>"
      );
    },
    handleDelete(row) {
      if (confirm("Are you sure you want to delete this slideshow?")) {
        this.$store
          .dispatch("slideshows/delete", {
            id: row.id,
          })
          .then(() => {
            // this.getSlideshows();

            // let correctIndex = null;
            // this.slideshowOptions.forEach((slideshow, index) => {
            //   if(slideshow.id === row.id) {
            //     correctIndex = index;
            //   }
            // });

            let correctIndex = this.slideshowOptions.findIndex((element) => element.id === row.id)

            if(correctIndex !== -1) {
              this.slideshowOptions.splice(correctIndex, 1);
            }

          });
      }
    },
    handleEditSlideshow() {
      const selectedSlideshow = this.slideshowOptions.find(
        (s) => s.id === this.slideshowSelected
      );
      this.modalSlideshow.id = selectedSlideshow.id;
      this.modalSlideshow.name = selectedSlideshow.name;
      this.modalSlideshow.interval = selectedSlideshow.interval;
      this.showModal = true;
    },
    handleClick(photoId, destination) {
      if (destination === "slideshow") {
        if (!this.slideshow.id) {
          this.$notify({
            title: "Slideshow",
            message: "Please select a slideshow or create a new one",
            type: "warning",
          });
          return;
        }
        if (
          this.slideshow.photos.findIndex((photo) => photo.id === photoId) !==
          -1
        ) {
          this.$notify({
            title: "Slideshow",
            message: "This photo is already in this slideshow",
            type: "warning",
          });
          return;
        }
        this.$store.dispatch("slideshows/add_photo", {
          photoId: photoId,
          slideshowId: this.slideshow.id,
        });
        const index = this.displayGroup.photos.findIndex(
          (photo) => photo.id === photoId
        );
        const photo = this.displayGroup.photos[index];
        this.displayGroup.photos.splice(index, 1);
        this.slideshow.photos.push(photo);
        this.populateSlideshow();
      }
      if (destination === "displayGroup") {
        this.$store.dispatch("slideshows/remove_photo", {
          photoId: photoId,
          slideshowId: this.slideshow.id,
        });
        const index = this.slideshow.photos.findIndex(
          (photo) => photo.id === photoId
        );
        const photo = this.slideshow.photos[index];
        this.slideshow.photos.splice(index, 1);
        if (
          this.displayGroup.photos.findIndex(
            (photo) => photo.id === photoId
          ) === -1
        ) {
          this.displayGroup.photos.push(photo);
        }

        this.populateDisplayGroup();
      }
    },
    startDrag: (evt, photo) => {
      evt.dataTransfer.dropEffect = "move";
      evt.dataTransfer.effectAllowed = "move";
      evt.dataTransfer.setData("photoId", photo.id);
    },
    onDrop(evt, destination) {
      const photoId = parseInt(evt.dataTransfer.getData("photoId"));
      if (destination === "slideshow") {
        if (!this.slideshow.id) {
          this.$notify({
            title: "Slideshow",
            message: "Please select a slideshow or create a new one",
            type: "warning",
          });
          return;
        }
        if (
          this.slideshow.photos.findIndex((photo) => photo.id === photoId) !==
          -1
        ) {
          this.$notify({
            title: "Slideshow",
            message: "This photo is already in this slideshow",
            type: "warning",
          });
          return;
        }
        this.$store.dispatch("slideshows/add_photo", {
          photoId: photoId,
          slideshowId: this.slideshow.id,
        });
        const index = this.displayGroup.photos.findIndex(
          (photo) => photo.id === photoId
        );
        const photo = this.displayGroup.photos[index];
        this.displayGroup.photos.splice(index, 1);
        this.slideshow.photos.push(photo);
        this.populateSlideshow();
      }
      if (destination === "displayGroup") {
        this.$store.dispatch("slideshows/remove_photo", {
          photoId: photoId,
          slideshowId: this.slideshow.id,
        });
        const index = this.slideshow.photos.findIndex(
          (photo) => photo.id === photoId
        );
        const photo = this.slideshow.photos[index];
        this.slideshow.photos.splice(index, 1);
        if (
          this.displayGroup.photos.findIndex(
            (photo) => photo.id === photoId
          ) === -1
        ) {
          this.displayGroup.photos.push(photo);
        }

        this.populateDisplayGroup();
      }
    },
    handleDisplayGroupSelect() {
      const displayGroup = this.displayGroupOptions.find(
        (dg) => dg.id === this.displayGroupSelected
      );
      if (displayGroup) {
        this.displayGroup = displayGroup;
        this.populateDisplayGroup();
      }
    },
    populateDisplayGroup() {
      this.$nextTick(() => {
        this.displayGroup.photos.forEach((photo, index) => {
          let element = this.$refs["displayGroupImage"][index];
          element.src = this.getS3Photo(
            photo.path,
            photo.file_name,
            150,
            150,
            60,
            false
          );
        });
      });
    },
    saveSlideshow() {
      const data = {
        id: this.modalSlideshow.id,
        name: this.modalSlideshow.name,
        interval: this.modalSlideshow.interval,
        outfitter_id: this.$store.getters["auth/outfitterId"],
      };
      this.$store.dispatch("slideshows/save_slideshow", data).then((resp) => {
        if (!resp.success) return;

        this.slideshow = resp.slideshow;
        this.slideshowSelected = resp.slideshow.id;
        this.getSlideshows();
        this.showModal = false;
        this.modalSlideshow = {
          id: null,
          name: null,
          interval: 5,
        };
        this.slideshow = resp.slideshow;
        this.populateSlideshow();
      });
    },
    populateSlideshow() {
      if (this.slideshow.photos) {
        this.$nextTick(() => {
          this.slideshow.photos.forEach((photo, index) => {
            let element = this.$refs["slideshowImage"][index];
            element.src = this.getS3Photo(
              photo.path,
              photo.file_name,
              150,
              150,
              60,
              false
            );
          });
        });
      }
    },
    handleSlideshowChange() {
      if (this.slideshowSelected) {
        if (this.slideshowSelected === "new") {
          this.slideshowSelected = null;
          this.showModal = true;
        } else {
          const slideshow = this.slideshowOptions.find(
            (s) => s.id === this.slideshowSelected
          );
          if (slideshow) {
            this.slideshow = slideshow;
            this.populateSlideshow();
          }
        }
      }
    },
    handleDateChange() {
      if (!this.date) {
        this.displayGroupOptions = [];
        return;
      }
      this.$store
        .dispatch("slideshows/get_displayGroups", {
          date: this.date,
          outfitterId: this.$store.getters["auth/outfitterId"],
        })
        .then((resp) => {
          if (!resp.success) return;

          this.displayGroupOptions = resp.displayGroups;
          if (!resp.displayGroups.length) {
            this.displayGroupSelected = null;
            this.$notify({
              title: "Display Groups",
              message: "No display groups found for this date",
              type: "warning",
            });
          }
        });
    },
    getSlideshows() {
      const id = localStorage.getItem("wwp-outfitter-id");
      if (id) {
        this.$store
          .dispatch("slideshows/get_slideshows", {
            outfitterId: id,
          })
          .then((resp) => {
            if (!resp.success) return;

            this.slideshowOptions = resp.slideshows;
            if (!resp.slideshows.length) {
              this.slideshowSelected = null;
              this.$notify({
                title: "Slideshows",
                message: "No slideshows found",
                type: "warning",
              });
            }
          });
      }
    },
  },
  mounted() {
    this.getSlideshows();
  },
};
</script>

<style scoped>
.drop-zone {
  background-color: #eee;
  margin-bottom: 10px;
  padding: 10px;
}

.drag-el {
  /*background-color: #fff;*/
  margin-bottom: 10px;
  padding: 5px;
  cursor: pointer;
}
>>> .link {
  color: blue;
}
>>> .link:hover {
  text-decoration: underline;
}
</style>
